export const translateRepairDecision = (clientDecision) => {
    const clientDecisionTranslations = {
        ACCEPTANCE: "Acceptation",
        REFUSAL: "Refus",
        WAITING_FOR_DECISION: "En attente de décision",
    };
    return clientDecisionTranslations[clientDecision] || clientDecision;
};